import { Chart } from 'chart.js/auto'
import ChartDataLabels from 'chartjs-plugin-datalabels'

function argMax(array) {
  return array.map((x, i) => [x, i]).reduce((r, a) => (a[0] > r[0] ? a : r))[1];
}

function argMin(array) {
  return array.map((x, i) => [x, i]).reduce((r, a) => (a[0] < r[0] ? a : r))[1];
}

let colorBlue = '#001b47';
let colorGreen = '#9aa403';

let motivationChart = null;
const createMotivationChart = async (sliderPoints) => {
  await Chart.register(ChartDataLabels)
  if (motivationChart !== null) {
    motivationChart.destroy()
  }
  let canvas = document.getElementById('motivation-chart-canvas');
  let chartUrl = "";
  motivationChart = new Chart(canvas, {
    type: 'bar',
    data: {
      labels: Object.keys(sliderPoints),
      datasets: [
        {
          data: Object.values(sliderPoints),
          backgroundColor: colorBlue
        }
      ]
    },
    options: {
      indexAxis: 'y',
      maintainAspectRatio: false,
      animation: false,
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          enabled: false
        }
      },
      scales: {
        x: {
          display: false,
          max: 13
        }
      }
    },
    plugins: {
      datalabels: {
        display: true,
        color: 'white',
        font: {
          weight: 'bold',
          size: 20,
        }
      }
    }
  })
  chartUrl = motivationChart.toBase64Image('image/png', 1);
  return chartUrl
}

let scoreChart = null;
const createScoreChart = async (scores) => {
  await Chart.unregister(ChartDataLabels)
  let colors = Object.values(scores).map(x => colorBlue);
  colors[argMax(Object.values(scores))] = colorGreen;
  if (scoreChart !== null) {
    scoreChart.destroy()
  }
  let canvas = document.getElementById('score-chart-canvas')
  let chartUrl = "";
  scoreChart = new Chart(canvas, {
    type: 'bar',
    data: {
      labels: Object.keys(scores),
      datasets: [
        {
          data: Object.values(scores),
          barPercentage: .75,
          backgroundColor: colors
        }
      ]
    },
    options: {
      indexAxis: 'y',
      responsive: true,
      maintainAspectRatio: false,
      animation: false,
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          enabled: false
        }
      },
      scales: {
        x: {
          grid: {
            display: true
          }
        },
        y: {
          display: true,
          grid: {
            display: false
          }
        }
      }
    },
    plugins: {
      datalabels: {
        display: false
      },
    },
  })
  chartUrl = scoreChart.toBase64Image('image/png', 1);
  return chartUrl
}

let footprintChart = null;
const createFootpintChart = async (scores) => {
  await Chart.unregister(ChartDataLabels)
  let colors = Object.values(scores).map(x => colorBlue);
  colors[argMin(Object.values(scores))] = colorGreen;
  if (footprintChart !== null) {
    footprintChart.destroy()
  }
  let canvas = document.getElementById('footprint-chart-canvas')
  let chartUrl = "";
  footprintChart = new Chart(canvas, {
    type: 'bar',
    data: {
      labels: Object.keys(scores),
      datasets: [
        {
          data: Object.values(scores),
          barPercentage: .75,
          backgroundColor: colors
        }
      ]
    },
    options: {
      indexAxis: 'y',
      responsive: true,
      maintainAspectRatio: false,
      animation: false,
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          enabled: false
        }
      },
      scales: {
        x: {
          grid: {
            display: true
          }
        },
        y: {
          display: true,
          grid: {
            display: false
          }
        }
      }
    },
    plugins: {
      datalabels: {
        display: false
      },
    },
  })
  chartUrl = footprintChart.toBase64Image('image/png', 1);
  return chartUrl

}

let powerChart = null;
const createPowerChart = async (scores) => {
  await Chart.unregister(ChartDataLabels)
  let colors = Object.values(scores).map(x => colorBlue);
  colors[argMin(Object.values(scores))] = colorGreen;
  if (powerChart !== null) {
    powerChart.destroy()
  }
  let canvas = document.getElementById('power-chart-canvas')
  let chartUrl = "";
  powerChart = new Chart(canvas, {
    type: 'bar',
    data: {
      labels: Object.keys(scores),
      datasets: [
        {
          data: Object.values(scores),
          barPercentage: .75,
          backgroundColor: colors
        }
      ]
    },
    options: {
      indexAxis: 'y',
      responsive: true,
      maintainAspectRatio: false,
      animation: false,
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          enabled: false
        }
      },
      scales: {
        x: {
          grid: {
            display: true
          }
        },
        y: {
          display: true,
          grid: {
            display: false
          }
        }
      }
    },
    plugins: {
      datalabels: {
        display: false
      },
    },
  })
  chartUrl = powerChart.toBase64Image('image/png', 1);
  return chartUrl
}

let outputChart = null;
const createOutputChart = async (scores) => {
  await Chart.unregister(ChartDataLabels)
  let colors = Object.values(scores).map(x => colorBlue);
  colors[argMax(Object.values(scores))] = colorGreen;
  if (outputChart !== null) {
    outputChart.destroy()
  }
  let canvas = document.getElementById('output-chart-canvas')
  let chartUrl = "";
  outputChart = new Chart(canvas, {
    type: 'bar',
    data: {
      labels: Object.keys(scores),
      datasets: [
        {
          data: Object.values(scores),
          barPercentage: .75,
          backgroundColor: colors
        }
      ]
    },
    options: {
      indexAxis: 'y',
      responsive: true,
      maintainAspectRatio: false,
      animation: false,
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          enabled: false
        }
      },
      scales: {
        x: {
          grid: {
            display: true
          }
        },
        y: {
          display: true,
          grid: {
            display: false
          }
        }
      }
    },
    plugins: {
      datalabels: {
        display: false
      },
    },
  })
  chartUrl = outputChart.toBase64Image('image/png', 1);
  return chartUrl
}

let investChart = null;
const createInvestChart = async (scores) => {
  await Chart.unregister(ChartDataLabels)
  let colors = Object.values(scores).map(x => colorBlue);
  colors[argMin(Object.values(scores))] = colorGreen;
  if (investChart !== null) {
    investChart.destroy()
  }
  let canvas = document.getElementById('invest-chart-canvas')
  let chartUrl = "";
  investChart = new Chart(canvas, {
    type: 'bar',
    data: {
      labels: Object.keys(scores),
      datasets: [
        {
          data: Object.values(scores),
          barPercentage: .75,
          backgroundColor: colors
        }
      ]
    },
    options: {
      indexAxis: 'y',
      responsive: true,
      maintainAspectRatio: false,
      animation: false,
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          enabled: false
        }
      },
      scales: {
        x: {
          grid: {
            display: true
          }
        },
        y: {
          display: true,
          grid: {
            display: false
          }
        }
      }
    },
    plugins: {
      datalabels: {
        display: false
      },
    },
  })
  chartUrl = investChart.toBase64Image('image/png', 1);
  return chartUrl
}

export { createMotivationChart, createScoreChart, createFootpintChart, createPowerChart, createOutputChart, createInvestChart }